import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Text, Heading } from 'rebass';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';

const StyledCard = styled(Card)`
  background: white;
  width: 90%;
  max-width: 500px;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

const RadioWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: flex-start;
  background: #f7f7f7;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 14px;

  &:hover {
    background: #eee;
  }

  input {
    margin-right: 12px;
    margin-top: 2px;
  }
`;

const SEND_REASON = gql`
  mutation appendIntakeNoLabChartAlert($noteToAdd: String!) {
    appendIntakeNoLabChartAlert(noteToAdd: $noteToAdd) {
      ok
    }
  }
`;

const IntakeOptionContinueNoLabModalContent = ({ onContinue, onCancel, client }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const options = [`I have labs and will upload them later`, `I'm waiting on labs and will upload them once available`, `I don't have labs and want to discuss potential lab orders with my provider`];
  
  const onSend = () => {
    if (client) {
      client.mutate({
        mutation: SEND_REASON,
        variables: {
          noteToAdd: selectedOption,
        },
      });
    }
    onContinue();
  };
  
  return (
    <StyledCard>
      <Heading as="h2" fontSize={3} mb={4}>
        Do you have recent thyroid labs?
      </Heading>
      <Text fontSize={'14px'} mb={3}>
        In order to prescribe medication or recommend a treatment plan, our providers need lab results from the past 4 months.
        <br />
        <br />
        Please select one of the following to continue:
      </Text>

      <RadioWrapper>
        {options.map((option, index) => (
          <RadioOption key={index}>
            <input type="radio" name="labOption" value={option} checked={selectedOption === option} onChange={() => setSelectedOption(option)} />
            {option}
          </RadioOption>
        ))}
      </RadioWrapper>

      <Flex justifyContent={'space-between'} mt={4}>
        <Button style={{ width: 'fit-content' }} variant={'outline'} onClick={onCancel}>
          Cancel
        </Button>
        <Button variant={'primary'} onClick={onSend} disabled={!selectedOption}>
          Continue
        </Button>
      </Flex>
    </StyledCard>
  );
};

export default withApollo(IntakeOptionContinueNoLabModalContent);
